module.exports = __webpack_public_path__ + "static/media/icomoon.1c266e13.eot";